import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { editorSelectors } from 'store/features/editor/selectors'
import { useCallback, useMemo } from 'react'

export const useGetActiveTimelineTtsAssetId = () => {
  const ttsAudios = useSelector(projectDataSelectors.ttsAudios)
  const activeTimelineItem = useSelector(editorSelectors.activeTimelineItem)

  const activeTimelineTtsId = useMemo(() => {
    return ttsAudios.find(audio => audio.id === activeTimelineItem.id)?.assetId
  }, [ttsAudios, activeTimelineItem.id])

  return activeTimelineTtsId ? Number(activeTimelineTtsId) : null
}

export const useGetActiveTtsItemTimelineId = () => {
  const ttsAudios = useSelector(projectDataSelectors.ttsAudios)

  const getActiveTtsItemTimelineId = useCallback(
    (id: number) => {
      const assetId = id.toString()
      return ttsAudios.find(audio => audio.assetId === assetId)?.id || null
    },
    [ttsAudios]
  )

  return getActiveTtsItemTimelineId
}
